import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { EmailService } from "src/app/services/email.service";
import { NzNotificationService } from "ng-zorro-antd";

@Component({
    selector: 'app-component-confirm-email',
    templateUrl: './confirm-email.component.html',
    styleUrls: ['./confirm-email.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmEmailComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;
    id: string;
    resReceiveEmail: string;
    resNopeReceiveEmail: string;
    s: string;
    isLoading: boolean = false;

    constructor(
        private router: Router,
        private emailService: EmailService,
        private titleService: Title,
        private nzNotification: NzNotificationService,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("Xác nhận email từ khách hàng");
    }

    ngOnInit() {
        this.activeRoute.queryParams.subscribe(
            res => {
                this.s = res['s'];
                if (this.s) {
                    this.confirmEmail();
                } else {
                    this.goToDefaultPage();
                }
            }
        )
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }

    nopeReceiveEmail() {
        this.isLoading = true;
        this.emailService.nopeReceiveEmail(this.resNopeReceiveEmail).subscribe(
            res => {
                if (res.isRedirect) {
                    this.router.navigate([res.redirectUrl], { queryParams: { _id: res.id } });
                }
            },
            error => {
                console.log(error);
                this.nzNotification.error(
                    "ERROR",
                    error
                );
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    receiveEmail() {
        this.isLoading = true;
        this.emailService.receiveEmail(this.resReceiveEmail).subscribe(
            res => {
                this.router.navigate([res.redirectUrl], { queryParams: { _id: res.id } });
            },
            error => {
                console.log(error);
                this.nzNotification.error(
                    "ERROR",
                    error
                );
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    confirmEmail() {
        this.isLoading = true;
        this.emailService.confirmEmail(this.s).subscribe(
            res => {
                if (res.isRedirect) {
                    this.router.navigate([res.redirectUrl]);
                }
                else if (res.data) {
                    console.log(res.data);
                    console.log(res.data.receiveEmail);
                    console.log(res.data.nopeReceiveEmail);
                    this.resReceiveEmail = res.data.receiveEmail;
                    this.resNopeReceiveEmail = res.data.nopeReceiveEmail;
                }
            },
            error => {
                console.log(error);
                this.nzNotification.error(
                    "ERROR",
                    error
                );
            },
            () => {
                this.isLoading = false;
            }
        )
    }
}